function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { heightsMapping, widthsMapping } from '../../theme/utils';
import { BackgroundStyle, BorderStyle } from './Container.theme.utils';
import { BackgroundColorOptions, BorderOptions } from './Container.types';
export var containerTheme = {
  baseStyle: _ref => {
    var {
      paddingX,
      paddingY,
      paddingTop,
      paddingBottom,
      paddingLeft,
      paddingRight,
      border,
      backgroundColor,
      width = 'full',
      height = 'auto',
      isSticky,
      alignItems,
      justifyContent,
      textAlign,
      overflow = 'hidden'
    } = _ref;
    return _objectSpread(_objectSpread({
      paddingX,
      paddingY,
      paddingTop,
      paddingBottom,
      paddingLeft,
      paddingRight,
      alignItems,
      justifyContent,
      textAlign
    }, BorderStyle[border]), {}, {
      backgroundColor: BackgroundStyle[backgroundColor],
      // This overrides Chakra's Box's default of maxWidth: 60ch
      maxWidth: 'none',
      width: widthsMapping[width],
      height: heightsMapping[height],
      overflow,
      position: isSticky ? 'sticky' : 'initial',
      top: isSticky ? 0 : 'initial',
      display: justifyContent || alignItems ? 'flex' : 'block'
    });
  },
  defaultProps: {
    paddingX: 'none',
    paddingY: 'none',
    paddingTop: undefined,
    paddingBottom: undefined,
    paddingLeft: undefined,
    paddingRight: undefined,
    backgroundColor: BackgroundColorOptions.Default,
    border: BorderOptions.None
  }
};
//# sourceMappingURL=Container.theme.js.map